import Reflux from "reflux";

export const ActionsAdAssistant = Reflux.createActions({
  setTaskStep: {},
  setJobTitle: {},
  setUploadedChatbotAssets: {},
  setPostData: {},
  setText: {},
  setCurrentAd: {},
  setCurrentAdVersion: {},
  setManualCampaignData: {},
  resetAssistantData: {},
  setAllAdCombinations: {},
  setEditModalOpen: {},
  setCompanyId: {},
  getCloudinaryImagesByCompanyId: { asyncResult: true },
  getOldUploadedImages: { asyncResult: true },
  generateThreadId: { asyncResult: true },
  generateAssistantMessage: { asyncResult: true },
  searchShutterstockAssets: { asyncResult: true },
  createAssistantCampaign: { asyncResult: true },
  updateAssistantCampaign: { asyncResult: true },
  getAdCombinations: { asyncResult: true },
  getAssistantCampaign: { asyncResult: true },
  getJobTitlesByCategoryId: { asyncResult: true },
  createAd: { asyncResult: true },
  updateAd: { asyncResult: true },
  getAdVersions: { asyncResult: true },
  setActiveAdVersion: { asyncResult: true },
  loadMoreVersions: { asyncResult: true },
  emptyAdVersions: {},
  setAdAssistantCampaignLive: { asyncResult: true },
  getAssistantKeywordsByJobTitle: { asyncResult: true },
  getAllCompanies: { asyncResult: true }
});
